import { API_BASE_URL } from '../../config';

function getAdminHeaders() {
  const token = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchSegmentAnalysisQuery(payload) {
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/sorgu`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getAdminHeaders()
    },
    body: JSON.stringify(payload || {})
  });
  if (!res.ok) {
    throw new Error(`segment_analizi_sorgu_failed_${res.status}`);
  }
  return res.json();
}

export async function fetchSegmentAnalysisDimensions() {
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/dimensions`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      ...getAdminHeaders()
    }
  });
  if (!res.ok) {
    throw new Error(`segment_analizi_dimensions_failed_${res.status}`);
  }
  return res.json();
}

export async function fetchSegmentAnalysisDictionaryOptions(query) {
  const params = new URLSearchParams({
    q: String(query || '').trim(),
    limit: '20'
  });
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/dictionary-search?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      ...getAdminHeaders()
    }
  });
  if (!res.ok) {
    throw new Error(`segment_analizi_dictionary_search_failed_${res.status}`);
  }
  return res.json();
}

export async function fetchSavedSegmentQueries({ scope = 'tum' } = {}) {
  const query = new URLSearchParams({ scope: String(scope || 'tum') });
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/saved-queries?${query.toString()}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      ...getAdminHeaders()
    }
  });
  if (!res.ok) {
    throw new Error(`segment_saved_queries_list_failed_${res.status}`);
  }
  return res.json();
}

export async function createSavedSegmentQuery(payload) {
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/saved-queries`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getAdminHeaders()
    },
    body: JSON.stringify(payload || {})
  });
  if (!res.ok) {
    throw new Error(`segment_saved_queries_create_failed_${res.status}`);
  }
  return res.json();
}

export async function updateSavedSegmentQuery(id, payload) {
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/saved-queries/${encodeURIComponent(String(id || ''))}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getAdminHeaders()
    },
    body: JSON.stringify(payload || {})
  });
  if (!res.ok) {
    throw new Error(`segment_saved_queries_update_failed_${res.status}`);
  }
  return res.json();
}

export async function deleteSavedSegmentQuery(id) {
  const res = await fetch(`${API_BASE_URL}/api/admin/dashboard/segment-analizi/saved-queries/${encodeURIComponent(String(id || ''))}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      ...getAdminHeaders()
    }
  });
  if (!res.ok) {
    throw new Error(`segment_saved_queries_delete_failed_${res.status}`);
  }
  return res.json();
}
